firebird.factory('videoPublisherIdService', [
    'logService',
    'configService',
    'attendeeListService',
    'videoroomService',
    function (logService, configService, attendeeListService, videoroomService) {
        const logger = logService.createLoggerWithSource('[videoroomCtrl] videoPublisherIdService');

        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            //Uses videoList to determine publishers and publisherIds
            self.refactorPublisherId = false;
            self.refactorBackwardCompatible = true; // if true, use publisherId=attendantId+offset, to be compatible with mobile.

            self.publisherIdScreen = 1000000000;
            self.publisherIdFile = 2000000000;
            self.publisherIdLimit = 3000000000;

            self.initPublisherId = initPublisherId;

            self.getScreenshareIdFromAttendantId = getScreenshareIdFromAttendantId;
            self.getAttendantIdFromScreenshareId = getAttendantIdFromScreenshareId;
            self.isScreenshareId = isScreenshareId;

            self.getSfuSendScreenParam = getSfuSendScreenParam;

            self.addPublisherIdToRequest = addPublisherIdToRequest;
            self.getPublisherIdFromFeedId = getPublisherIdFromFeedId;
            self.getSfuVideoMuteData = getSfuVideoMuteData;

            self.getPublisherObj = getPublisherObj;
            self.findAttendee = findAttendee;
        }

        // enable from config
        function initPublisherId() {
            // refactor publisher ID and related
            self.refactorPublisherId = configService.getValue('refactorPublisherId') == 'true';
            self.refactorBackwardCompatible = configService.getClientValue('refactorBackwardCompatible') != 'false'; // default true
            logger.log(
                'videoroomCtrl - refactorPublisherId=' +
                    self.refactorPublisherId +
                    ' refactorBackwardCompatible=' +
                    self.refactorBackwardCompatible
            );

            // number of 0s in publisherIdScree and publisherIdFile.
            var publisherIdSize = configService.getServerValue('publisherIdSize');
            if (publisherIdSize) {
                publisherIdSize = publisherIdSize == 'true' ? 12 : parseInt(publisherIdSize);
                if (publisherIdSize >= 9) {
                    self.publisherIdScreen = parseInt('1'.padEnd(publisherIdSize + 1, '0'));
                    self.publisherIdFile = parseInt('2'.padEnd(publisherIdSize + 1, '0'));
                    self.publisherIdLimit = parseInt('3'.padEnd(publisherIdSize + 1, '0'));
                }
            }
        }

        // a relaxed version of findAttendee that allows string for attendantId, i.e., == instead of ===
        function findAttendee(attendantId) {
            var attendeeList = attendeeListService.getAttendeeList();
            for (i = 0; i < attendeeList.length; i++) {
                if (attendeeList[i].attendantId == attendantId) {
                    return attendeeList[i];
                }
            }

            return false;
        }

        // Note that screen share stream is published with an id prefixed by 10^9 to
        // distinguish it from video stream of the same user.
        function getScreenshareIdFromAttendantId(id) {
            if (self.refactorPublisherId) {
                return id + (!self.fileplay ? '-screen' : '-file');
            } else {
                if (id >= self.publisherIdScreen) {
                    throw Error('id is too long: ' + id);
                }
                return id + (!self.fileplay ? self.publisherIdScreen : self.publisherIdFile);
            }
        }

        function getAttendantIdFromScreenshareId(id, ignoreType) {
            if (self.refactorPublisherId) {
                var result = parseInt(('' + id).split('-')[0]);
                if (ignoreType) {
                    // no need to check if suffix is right
                    return result;
                } // must check for suffix, and return invalid if wrong.
                var suffix = ('' + id).split('-')[1];
                if ((suffix == 'screen' && !self.fileplay) || (suffix == 'file' && self.fileplay)) {
                    return result;
                }
                return 0; // invalid;
            } else {
                if (ignoreType) {
                    // ignore fileplay or not.
                    return id % self.publisherIdScreen;
                }
                return id - (!self.fileplay ? self.publisherIdScreen : self.publisherIdFile);
            }
        }

        // Check if the supplied id is a screenshare id or not?
        function isScreenshareId(id) {
            if (self.refactorPublisherId) {
                var suffix = ('' + id).split('-')[1];
                return (!self.fileplay && suffix == 'screen') || (self.fileplay && suffix == 'file');
            } else {
                return (
                    (!self.fileplay && id > self.publisherIdScreen && id < self.publisherIdFile) ||
                    (self.fileplay && id > self.publisherIdFile && id < self.publisherIdLimit)
                );
            }
        }

        function getSfuSendScreenParam() {
            return self.refactorPublisherId
                ? { publisherId: self.myscreenid, type: self.fileplay ? 'file' : 'screen' }
                : undefined;
        }

        // add "id" attribute to the Janus request if needed.
        // it does not add id refactorPublisherId is true AND refactorBackwardCompatible is false.
        function addPublisherIdToRequest(request, is_screen) {
            if (!self.refactorPublisherId || self.refactorBackwardCompatible) {
                request.id =
                    self.attendantId +
                    (is_screen ? (!self.fileplay ? self.publisherIdScreen : self.publisherIdFile) : 0);
            } // else do not include id attribute
        }

        function getPublisherObj(attendantId, is_screen) {
            //Leaving here for dev purposes
            // console.log('attendantId=' + attendantId + ', videoList=' + JSON.stringify(videoroomService.getVideoList()));
            return videoroomService.getVideoList().find(function (publisher) {
                var idMatch = publisher.attendantId == attendantId;
                var typeMatch;

                if (is_screen) {
                    typeMatch = self.fileplay ? publisher.type === 'file' : publisher.type === 'screen';
                } else {
                    typeMatch = publisher.type === 'video';
                }

                return idMatch && typeMatch;
            });
        }

        function getPublisherIdFromFeedId(id, is_screen) {
            if (self.refactorPublisherId) {
                var ido = id;
                if (is_screen) {
                    id = self.getAttendantIdFromScreenshareId(id);
                }
                publisherObj = self.getPublisherObj(id, is_screen);
                if (publisherObj) {
                    //Used only for the subscribe request... the feed ID will still be the attendantId
                    return publisherObj.publisherId;
                } else {
                    logger.warn(
                        'getPublisherIdFromFeedId',
                        'video publisher not found in list for id=' + id + ', is_screen=' + is_screen
                    );
                    // TODO: fallback for now. fix later.
                    if (self.refactorBackwardCompatible) {
                        id =
                            parseInt(id) +
                            (is_screen ? (!self.fileplay ? self.publisherIdScreen : self.publisherIdFile) : 0);
                    } else {
                        id = ido; // revert
                    }
                }
            }
            return id;
        }

        function getSfuVideoMuteData(value) {
            var data = value;

            if (self.refactorPublisherId) {
                data = { muteVideo: value, type: 'video' };
                if (!value) {
                    // unmute, include myid
                    data.publisherId = self.myid;
                }
            }

            return data;
        }
    }
]);
